import * as Types from '../constants/actionTypes';

const defaultState = {
  allStatuses: [],
  statusesError: null
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case Types.STATUSES_LIST:
      return {
        ...state,
        allStatuses: action.allStatuses
      }
    case Types.STATUSES_ERROR:
      return {
        ...state,
        statusesError: action.statusesError
      }
    default:
      return state
  }
}
